/// <reference path="../types/index.d.ts" />

import '../client_forms/tcamorewed/style.css';
import FormStructure from './tcamorewed/form_structure';

export default FormStructure;